import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
import { track } from '@amplitude/analytics-browser'

const CnameBanner = ({ classes }) => {
  return (
    <div className={classes.certificationContainer}>
      <div className={classes.content}>
        <div className={classes.bannerContainer}>
          <div className={classes.bannerContent}>
            <Typography className={classes.bannerText}>
              Would you like to customize your links?
            </Typography>
            <Typography className={classes.bannerSubText}>
              With a higher plan, you will be able to connect several custom
              domains and offer your courses and learning paths with your own
              link!
            </Typography>
            <CoreButton
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                window.location.href = '/pricing'
                track('limit_warning_upgrade', {
                  from: 'cname_limit_upgrade',
                })
              }}
            >
              See Plans & Upgrade
            </CoreButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(CnameBanner)
